let topicWeightCopyHandlerBound = false;

function handleTopicWeightCopy(e) {
  const btn = e.target.closest('.topic-weight-copy-btn');
  if (!btn) return;

  const inputContainer = btn.closest('.col-4');
  if (!inputContainer) return;

  const input = inputContainer.querySelector('.topic-weight-input');
  if (!input) return;

  const form = btn.closest('form');
  const targets = form
    ? form.querySelectorAll('.topic-weight-input')
    : document.querySelectorAll('.topic-weight-input');

  targets.forEach(el => { el.value = input.value; });
}

export default class AdminDataFrameworksTopicsEdit {

  constructor() {}

  render() {
    // Delegated handler — bind once at the document level to avoid
    // accumulating duplicate listeners across Turbo page loads.
    // Scopes the copy to all .topic-weight-input fields within the same form.
    if (topicWeightCopyHandlerBound) return;

    document.addEventListener('click', handleTopicWeightCopy);
    topicWeightCopyHandlerBound = true;
  }

}
